module.exports = __webpack_public_path__ + "刘会平-f5e094ee.png";